const { instance } = require('./url')

async function getAddons(typeId='') {
    if (typeId) {
        return await instance.get('/quote/addons/' + typeId)
    }
    return await instance.get('/quote/addons')
}

async function getAllAddons() {
    return await instance.get('/quote/alladdons')
}

// async function convertAddons(typeId, addons) {
//     return await instance.post('/quote/convert_addons', {
//         'type_id': typeId,
//         'addons': addons
//     })
// }

// MARK: All Addons

async function updateAllAddonsCostOrderIndex(type, cost_label, new_order) {
    return await instance.put('/admin/alladdonscostorderindex', {
        'type': type,
        'cost_label': cost_label,
        'new_order': new_order,
    })
}

async function updateAllAddons(addon) {
    return await instance.put('/admin/alladdons',
        {'addon': addon})
}

async function insertAllAddons(addon) {
    return await instance.post('/admin/alladdons',
        {'addon': addon})
}

async function deleteAllAddons(id) {
    return await instance.delete('/admin/alladdons/' + id,
        {})
}


// MARK: Sign Type

async function updateSignType(type) {
    return await instance.put('/admin/signtype',
        {'type': type})
}

async function insertSignTypes(types) {
    return await instance.post('/admin/signtypes',
        {'types': types})
}

async function insertSignType(type) {
    return await instance.post('/admin/signtype',
        {'type': type})
}

async function deleteSignType(id) {
    return await instance.delete('/admin/signtype/' + id,
        {})
}

export {
    getAddons, getAllAddons,
    // convertAddons,
    updateAllAddonsCostOrderIndex,
    updateAllAddons,
    insertAllAddons,
    deleteAllAddons,

    updateSignType,
    insertSignTypes,
    insertSignType,
    deleteSignType,
}

